import {
  EditableProspectLoaderParams,
  EditableProspectLoaderResult,
} from '@/experiences/sales-portal/domain/prospects/screens/prospect-detail/types';
import { useSalesPortalEditableProspectQuery } from '@/experiences/sales-portal/domain/prospects/screens/prospect-detail/blocs/documents/sales-portal-editable-prospect.generated';

/**
 * Loader fetches editable prospect information from the API
 *
 * @param onCompleted - Callback invoked when data is loaded
 * @param restaurantUUID - UUID of the restaurant
 * @param supplierUUID - UUID of the supplier
 * @returns {@link EditableProspectLoaderResult}
 */
export const useEditableProspectLoader = ({
  onCompleted,
  restaurantUUID,
  supplierUUID,
}: EditableProspectLoaderParams): EditableProspectLoaderResult => {
  const { data, loading, error, refetch } = useSalesPortalEditableProspectQuery(
    {
      fetchPolicy: 'cache-and-network',
      onCompleted: (queryData) => {
        if (queryData?.getSalesPortalProspectDetails && onCompleted) {
          onCompleted(queryData.getSalesPortalProspectDetails);
        }
      },
      variables: { restaurantUUID, supplierUUID },
    },
  );

  return {
    data: data?.getSalesPortalProspectDetails ?? null,
    error,
    loading,
    refetch: () => refetch().catch(() => {}),
  };
};
